import { ISupportBanner } from 'src/app/components/support-banner/support-banner.component';

export const supportBannerMockData: ISupportBanner = {
  h2: 'Чому нас треба підтримувати?',
  text: 'Щодня ми працюємо над тим, щоб більше 500 тисяч людей з деменцією в Україні та їх родичів могли жити повноцінно та щасливо. Для цього ми надаємо фахові консультації лікарів, доглядальників, психологів та інших фахівців, проводимо заходи для людей з деменцією та їх родин, перекладаємо посібники, організовуємо інформаційні кампанії, створюємо пам’ятки та ініціюємо зміни на державному рівні.',
};
